import styled from 'styled-components';

import { breakpoints, colors, fontFamily } from '../../ui/variables';

export const QuantitativeAnalysisStyle = styled.div`
  ${fontFamily.sourceSansPro.regular};
  background-color: ${colors.softBlue};
  border-radius: 12px;
  color: ${colors.white};
  padding: 12px 0;

  .table-head {
    color: ${colors.veryPaleBlue};
    padding-bottom: 20px;

    .head-title {
      ${fontFamily.sourceSansPro.bold};
      font-size: 18px;
      line-height: 1.3333;
      margin-bottom: 16px;
      padding: 0 20px;

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        padding: 0 12px;
      }

      @media (min-width: ${breakpoints.uxga.width}px) {
        padding: 0 20px;
      }
    }

    .main-data {
      display: flex;
      margin-bottom: 20px;
      padding: 0 20px;
      width: 90%;

      @media (min-width: ${breakpoints.iphone8.width}px) {
        width: 75%;
      }

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        width: 100%;
        padding: 0 12px;
      }

      @media (min-width: ${breakpoints.uxga.width}px) {
        padding: 0 20px;
      }

      .main-data-item {
        &:nth-child(1),
        &:nth-child(2) {
          @media (min-width: ${breakpoints.wxgaPlus.width}px) {
            flex-basis: 35%;
          }
        }

        &:nth-child(3) {
          @media (min-width: ${breakpoints.wxgaPlus.width}px) {
            flex-basis: 30%;
          }
        }

        .item-label {
          font-size: 12px;
          white-space: nowrap;
        }

        .item-value {
          ${fontFamily.sourceSansPro.bold};
          font-size: 18px;
          line-height: 1.3333;
        }
      }
    }
  }

  .general-data {
    .general-data-item {
      align-items: center;
      display: flex;
      min-height: 52px;
      padding: 8px 20px;

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        padding: 8px 12px;
      }

      @media (min-width: ${breakpoints.uxga.width}px) {
        padding: 8px 20px;
      }

      &.theme-dark {
        background-color: ${colors.darkModerateBlue};
      }

      .item-label {
        ${fontFamily.sourceSansPro.bold};
        /* max-width: 40%; */ /* hide status */
        /* min-width: 40%; */ /* hide status */
        font-size: 12px;
        line-height: 1.3333;
        max-width: 57.5%; /* hide status */
        min-width: 57.5%; /* hide status */
        padding-right: 20px;

        .label-unit {
          ${fontFamily.sourceSansPro.regular};
          white-space: nowrap;
        }
      }

      .item-value {
        /* max-width: 30%; */ /* hide status */
        /* min-width: 30%; */ /* hide status */
        font-size: 14px;
        line-height: 1.2857;
        max-width: 42.5%; /* hide status */
        min-width: 42.5%; /* hide status */
        text-align: left;
      }

      .item-status {
        display: none; /* hide status */
        font-size: 14px;
        line-height: 1.2857;
        max-width: 30%;
        min-width: 30%;
        padding-left: 44px;
        position: relative;
        text-align: left;

        &:after {
          border-radius: 50%;
          content: '';
          display: block;
          height: 12px;
          left: 16px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 12px;
        }

        &:first-letter {
          text-transform: uppercase;
        }

        &.status-diffuse,
        &.status-severe {
          &:after {
            background-color: ${colors.softRed};
          }
        }

        &.status-mild,
        &.status-moderate {
          &:after {
            background-color: ${colors.softYellow};
          }
        }

        &.status-normal {
          &:after {
            background-color: ${colors.limeGreen};
          }
        }

        &.status-undefined {
          &:after {
            background-color: ${colors.veryLightGrayishBlue};
          }
        }
      }
    }
  }
`;
